import { render, staticRenderFns } from "./ConfigParamForm.vue?vue&type=template&id=8525fa06&scoped=true&"
import script from "./ConfigParamForm.vue?vue&type=script&lang=js&"
export * from "./ConfigParamForm.vue?vue&type=script&lang=js&"
import style0 from "./ConfigParamForm.vue?vue&type=style&index=0&id=8525fa06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8525fa06",
  null
  
)

export default component.exports